import { useEffect } from 'react';

// Custom hook to observe the DOM for the insertion of any red venture widget
// And set a "tid" attribute on the iframe with the value being the id of the post where the widget is located

const useRedVentureIframeObserver = (
  targetRef: React.RefObject<HTMLElement>,
  postId: number | string,
  shouldUse = false,
) => {
  useEffect(() => {
    if (!shouldUse) return () => {};
    const handleIframeLoad = (iframeEl: HTMLIFrameElement) => {
      const iframeElement = iframeEl;
      const iframeSrc = iframeElement.getAttribute('src');
      if (iframeSrc) {
        try {
          const url = new URL(iframeSrc);
          url.searchParams.set('tid', `${postId}`);
          iframeElement.src = url.toString();
        } catch {
          /* url might not be valid */
        }
      }
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeName === 'IFRAME') {
            const iframeElement = node as HTMLIFrameElement;
            const dataSrc = iframeElement.getAttribute('data-src');
            if (dataSrc && dataSrc.includes('myfinance')) {
              handleIframeLoad(iframeElement);
            }
          }
        });
      });
    });

    if (targetRef.current) {
      observer.observe(targetRef.current, { childList: true, subtree: true });
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [postId, shouldUse, targetRef]);
};

export default useRedVentureIframeObserver;
